import React from 'react'
import './AddVehicle/VehicleComponent.css'
import { useTranslation } from 'react-i18next'

export const VehicleCard = ({
	vehicle,
	selected,
	onSelect,
	register,
	name,
}) => {
	const {
		volume = 'Non spécifié',
		length,
		width,
		height,
		payload,
		pallets = 'Non spécifié',
	} = vehicle.specs
    const {t} = useTranslation()
	return (
		<div className='vehicle-card-container'>
			<div className='vehicle-card-image-container'>
				<img
					src={vehicle.image}
					className='vehicle-card-image'
					alt={vehicle.name}
				/>
			</div>

			<div className='vehicle-card-selection-container'>
				<input
					type='radio'
					className='vehicle-card-radio-input'
					{...register(name, {
						required:t("select_vehicle_type_err2"),
					})}
					value={vehicle.name}
					checked={selected}
					onChange={onSelect}
				/>
				<span className='vehicle-card-name'>{vehicle.name}</span>
			</div>

			<div className='vehicle-card-payload-container'>
				<span className='vehicle-card-payload'>
					{vehicle.specs.payload}
				</span>
			</div>

			<div className='vehicle-card-details-container'>
				<span className='vehicle-card-details-text'>
					{t("vehicle_detail1")} : {volume}
				</span>
				<span className='vehicle-card-details-text'>
					{t("vehicle_detail2")} : {length}
				</span>
				<span className='vehicle-card-details-text'>
					{t("vehicle_detail3")} : {width}
				</span>
				<span className='vehicle-card-details-text'>
					{t("vehicle_detail4")} : {height}
				</span>
				<span className='vehicle-card-details-text'>
					{t("vehicle_detail5")} : {payload}
				</span>
				<span className='vehicle-card-details-text'>
					{t("vehicle_detail6")} : {pallets}
				</span>
			</div>
		</div>
	)
}
